import { Grid2 as Grid, Card, CardContent, IconButton, Typography } from "@mui/material"
import { Edit, Delete } from "@mui/icons-material"
import { Sequenza } from "../types"
import { InlineField } from "./DataField"
import { useTranslation } from "react-i18next"
import useUserCanWriteAndDelete from "../hooks/permissions"
import { useIsMobile } from "../hooks/mobile"

type SequenzaCardProps = {
  sequenza: Sequenza
  onDelete: (sequenza: Sequenza) => void
  onUpdate: (sequenza: Sequenza) => void
  currentSequence?: Sequenza | null
}

export default function SequenzaCard({ sequenza, onDelete, onUpdate, currentSequence = null }: SequenzaCardProps) {
  const { t, i18n } = useTranslation()
  const isCurrent = currentSequence?.id === sequenza.id
  const userCanWriteAndDelete = useUserCanWriteAndDelete()
  const isMobile = useIsMobile()

  return (
    <Card
      sx={{
        borderLeft: 4,
        borderColor: isCurrent ? "primary.main" : "secondary.light",
      }}
    >
      <CardContent sx={{ position: "relative" }}>
        {userCanWriteAndDelete && !isMobile && (
          <IconButton
            onClick={() => onUpdate(sequenza)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "primary.main",
            }}
            aria-label="edit"
          >
            <Edit />
          </IconButton>
        )}
        <Typography variant="button" sx={{ mb: 1 }}>
          {t("general.sequenza")} {sequenza.numero_sequenza}
        </Typography>
        <Grid container spacing={1}>
          <Grid size={4}>
            <InlineField label={t("sequenza.tcin")} value={sequenza.tcin} />
          </Grid>
          <Grid size={4}>
            <InlineField label={t("sequenza.tcout")} value={sequenza.tcout} />
          </Grid>
        </Grid>

        <InlineField label={t("general.descrizione")} value={
          i18n.language === "it" ? sequenza.descrizione_it : sequenza.descrizione_en
        } />

        <InlineField label={t("general.note")} value={sequenza.note} />
        {userCanWriteAndDelete && !isMobile && (
          <IconButton
            onClick={() => onDelete(sequenza)}
            sx={{
              position: "absolute",
              bottom: 8,
              right: 8,
              color: "grey.400",
              "&:hover": {
                color: "error.main",
              },
            }}
            aria-label="delete"
          >
            <Delete />
          </IconButton>
        )}
      </CardContent>
    </Card>
  )
}
